import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { GradientIcon } from './gradients/GradientIcon';
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';

type PaginationOptionsProps = {
  numItems: number;
  currentPage: number;
  rowsPerPage: number;
  handleRowsPerPage: (e: SelectChangeEvent) => void;
  handleNextPage: () => void;
  handlePrevPage: () => void;
};

export function PaginationOptions({
  currentPage,
  rowsPerPage,
  numItems,
  handleRowsPerPage,
  handleNextPage,
  handlePrevPage,
}: PaginationOptionsProps) {
  const isNextArrowDisabled = currentPage === Math.ceil(numItems / rowsPerPage);
  const isPrevArrowDisabled = currentPage === 1;
  const theme = useTheme();
  return (
    <>
      {' '}
      {numItems > 5 ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            py: 3,
            px: 4,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <Typography
              variant="body1"
              sx={{ color: theme.palette.text.secondary, mx: 2 }}
            >
              Rows per page:
            </Typography>
            <Select
              value={`${rowsPerPage}`}
              onChange={handleRowsPerPage}
              inputProps={{
                name: 'rowsPerPage',
                id: 'rowsPerPage',
                sx: { py: 2 },
              }}
            >
              {/* must disable these options when there are not enough items left */}
              <MenuItem value={5}>5</MenuItem>
              {numItems - currentPage * 5 > 0 && (
                <MenuItem value={10}>10</MenuItem>
              )}
              {numItems - currentPage * 10 > 0 && (
                <MenuItem value={20}>20</MenuItem>
              )}
            </Select>
          </Box>
          <Box sx={{ mx: 4 }}>
            <Typography>
              {(currentPage - 1) * rowsPerPage + 1} -{' '}
              {currentPage * rowsPerPage < numItems
                ? currentPage * rowsPerPage
                : numItems}{' '}
              of {numItems}
            </Typography>
          </Box>
          <Box
            sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
              onClick={isPrevArrowDisabled ? undefined : handlePrevPage}
            >
              <IconButton disabled={isPrevArrowDisabled}>
                {isPrevArrowDisabled ? (
                  <ChevronLeftRoundedIcon />
                ) : (
                  <GradientIcon IconComponent={ChevronLeftRoundedIcon} />
                )}
              </IconButton>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
              onClick={isNextArrowDisabled ? undefined : handleNextPage}
            >
              <IconButton disabled={isNextArrowDisabled}>
                {isNextArrowDisabled ? (
                  <ChevronRightRoundedIcon />
                ) : (
                  <GradientIcon IconComponent={ChevronRightRoundedIcon} />
                )}
              </IconButton>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box />
      )}{' '}
    </>
  );
}
